import { NextPage } from 'next'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { BookList } from 'web_core/assets/book/List'
import { CategorySelector } from 'web_core/assets/category'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useQueryData } from 'web_core/hooks'
import { useESBooks } from 'web_core/hooks/models'
import { isBlank } from 'web_core/utils'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { Heading } from '~/components/Utils/Heading'
import { SearchNavSelector } from '~/components/Utils/SearchNavSelector'
import { useLayoutProperty } from '~/context/layout_property'
import { bookSearchBreadcrumb } from '~/utils'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const keyword = useQueryData('keyword')
  const [categoryId, setCategoryId] = useState<string>()
  const { books, loadMore, isReachingEnd, isLoadingMore } = useESBooks(
    !isBlank(keyword) && keyword !== ''
      ? {
          type: 'query',
          locale: 'ja',
          category_ids:
            !isBlank(categoryId) && categoryId !== ''
              ? [categoryId]
              : undefined,
          keyword,
          order: 'score desc',
        }
      : null
  )
  const title =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連する本`
      : '本の検索'
  const description =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連する本の一覧を閲覧できます。`
      : 'Mathlogの本検索ページです。キーワードを入力して目的の本を見つけましょう。'

  const { headerHeight } = useLayoutProperty()
  return (
    <DefaultLayout
      head={{ title, description, keyword: keyword ?? undefined }}
      navLinks={{ pc: true, tablet: true, sp: true }}
      categoriesMenu={{ pc: true }}
      leftSidebar
      rightSideBar
    >
      {bookSearchBreadcrumb.toReactNode()}
      <Heading title={title} icon={FaSearch} />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2 mb-md-4"
        style={{ top: headerHeight }}
      >
        <SearchNavSelector
          active="books"
          link="/[target]"
          keyword={keyword}
          className="mb-2 mb-md-4"
        />
        <CategorySelector
          className="fs-7"
          style={{ maxWidth: 300 }}
          value={categoryId}
          onChange={setCategoryId}
          undefinedLabel={'全てのカテゴリ'}
        />
      </div>
      {!isBlank(keyword) && keyword !== '' ? (
        <InfiniteScroll
          loadMore={async () => {
            if (isLoadingMore === false && isReachingEnd === false)
              await loadMore()
          }}
          hasMore={isReachingEnd === false}
          loader={<LoadingSpinner />}
        >
          {books && <BookList books={books} />}
        </InfiniteScroll>
      ) : (
        <p>検索キーワードを入力してください。</p>
      )}
    </DefaultLayout>
  )
}

export default Page
